<template>
	<div class="">
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: 'bidding' }"><span class="text-sm text-666">招标信息</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">详情</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div class="bg-white padding-sm radius">
						<div class="text-32 text-000 text-bold text-left">{{title}}</div>
						<div class="flex justify-between align-center">
							<div class="margin-top-sm">
								<div class="flex align-center justify-between" v-if="user">
									<p class="flex align-center">
										<img :src="user.avatar" class="block-30">
										<span class="text-sm text-333 margin-left-xs">{{user.nick_name}}</span>
									</p>
									<div class="flex align-center margin-left-xs">
										<img v-if="user.is_real == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/authentication.png" mode=""></img>
										
										<img v-if="user.is_real_company == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/enterprise.png" mode=""></img>
										<img v-else class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/random.png" mode=""></img>
										<div class="text-999 text-sm">{{user.is_real_company == 2?'企业已认证':user.is_real == 2?'个人已认证':'未认证'}}</div>
									</div>
								</div>
								<div class="flex align-center justify-between margin-top-xs">
									<p>
										<i class="el-icon-location-outline"></i>
										<span class="text-sm text-666">{{area}}</span>
									</p>
									<p>
										<span class="text-sm text-999">费用预算</span>
										<span class="text-prices">￥{{budget}}/月</span>
									</p>
								</div>
							</div>
							<div class="flex align-center">
								<div class="colt flex align-center justify-center pointer" @click="chosecoll">
									<i class="el-icon-star-off text-theme"></i>
									<p class="margin-left-xs text-666">{{coll?'已收藏':'收藏'}}</p>
								</div>
								<div class="callbtns flex align-center justify-center margin-left-xs pointer" @click="callphone()">
									<img class="call-icon" src="../../assets/img/call-icon.png" >
									<p class="text-white margin-left-xs">电话联系</p>
								</div>
							</div>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">详情</p>
						<p class="text-left margin-top-sm">{{content}}</p>
					</div>
					
				</div>
				<div class="margin-left" v-if="newlist.length != 0">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm ">最新招标</p>
					</div>
					<div v-for="(item,indx) in newlist" :key="indx">
						<BidList :data="item" :width="387" :height="168" :size="18"></BidList>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Top from '@/components/public/top.vue';
	import BidList from '@/components/list/bid-list.vue';
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			Top,
			BidList
		},
		name: '',
		data() {
			return {
				id:0,
				title:'',//
				content:'',//
				area:'',//
				budget:'',//
				coll:'',//
				newlist:[],//最新列表
				user:null,
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','bidding')
			this.id = this.$route.query.id
			this.getdetail()
			this.getnewlist()
		},
		methods: {
			back(){
				this.$router.back()
			},
			//收藏取消收藏
			chosecoll() {
				this.ajax('post', '/api/collection/add', {
					type_id: this.id,
					type: 3
				}, res => {
					if (res.status == 200) {
						this.coll = !this.coll
						this.getdetail()
					} else {
						this.careful = ''
					}
				})
			
			},
			callphone() {
				
				let phone_num = this.user&&this.user.phone
				console.log(phone_num);
				this.$alert('联系电话为：' + phone_num, '提示', {
					confirmButtonText: '确定',
					callback: action => {
			
					}
				});
			},
			/**
			 * 详情
			 * */
			getdetail(){
				this.ajax('get', '/api/pc/bidding/getInfo', {
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.title = res.data.title
						this.content = res.data.content
						this.area = res.data.area
						this.budget = res.data.budget
						this.coll = res.data.coll
						this.user = res.data.user
					}
				})
			},
			/**
			 * 获取最新租聘列表
			 **/
			getnewlist(){
				this.ajax('get', '/api/pc/bidding/getBidding', {
					page:1,
					limit:3,
					
				}, res => {
					console.log('getlist',res);
					if(res.status == 200){
						this.newlist = res.data.data
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.text-32{
		font-size: 32px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.block-30{
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.tip{
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204,204,204,0.3000);
		border-radius: 20px;
	}
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/view/index/bidding-detail.vue